/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemNote } from '../../models/system-note';

export interface GetSystemNote$Params {
  systemNoteId: number;
}

export function getSystemNote(http: HttpClient, rootUrl: string, params: GetSystemNote$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemNote>> {
  const rb = new RequestBuilder(rootUrl, getSystemNote.PATH, 'get');
  if (params) {
    rb.path('systemNoteId', params.systemNoteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemNote>;
    })
  );
}

getSystemNote.PATH = '/api/system/note/{systemNoteId}';
